const TaskEditorColorMapping = [
  {
      "color": "#B71C1C",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#880E4F",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#4A148C",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#311B92",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#1A237E",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#D32F2F",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#C2185B",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#7B1FA2",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#512DA8",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#303F9F",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#F44336",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#E91E63",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#9C27B0",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#673AB7",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#3F51B5",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#E57373",
      "text_color": "#000000"
  },
  {
      "color": "#F06292",
      "text_color": "#000000"
  },
  {
      "color": "#BA68C8",
      "text_color": "#000000"
  },
  {
      "color": "#9575CD",
      "text_color": "#000000"
  },
  {
      "color": "#7986CB",
      "text_color": "#000000"
  },
  {
      "color": "#FFCDD2",
      "text_color": "#000000"
  },
  {
      "color": "#F8BBD0",
      "text_color": "#000000"
  },
  {
      "color": "#E1BEE7",
      "text_color": "#000000"
  },
  {
      "color": "#D1C4E9",
      "text_color": "#000000"
  },
  {
      "color": "#C5CAE9",
      "text_color": "#000000"
  },
  {
      "color": "#0D47A1",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#01579B",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#006064",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#004D40",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#194D33",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#1976D2",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#0288D1",
      "text_color": "#000000"
  },
  {
      "color": "#0097A7",
      "text_color": "#000000"
  },
  {
      "color": "#00796B",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#388E3C",
      "text_color": "#000000"
  },
  {
      "color": "#2196F3",
      "text_color": "#000000"
  },
  {
      "color": "#03A9F4",
      "text_color": "#000000"
  },
  {
      "color": "#00BCD4",
      "text_color": "#000000"
  },
  {
      "color": "#009688",
      "text_color": "#000000"
  },
  {
      "color": "#4CAF50",
      "text_color": "#000000"
  },
  {
      "color": "#64B5F6",
      "text_color": "#000000"
  },
  {
      "color": "#4FC3F7",
      "text_color": "#000000"
  },
  {
      "color": "#4DD0E1",
      "text_color": "#000000"
  },
  {
      "color": "#4DB6AC",
      "text_color": "#000000"
  },
  {
      "color": "#81C784",
      "text_color": "#000000"
  },
  {
      "color": "#BBDEFB",
      "text_color": "#000000"
  },
  {
      "color": "#B3E5FC",
      "text_color": "#000000"
  },
  {
      "color": "#B2EBF2",
      "text_color": "#000000"
  },
  {
      "color": "#B2DFDB",
      "text_color": "#000000"
  },
  {
      "color": "#C8E6C9",
      "text_color": "#000000"
  },
  {
      "color": "#33691E",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#827717",
      "text_color": "#000000"
  },
  {
      "color": "#F57F17",
      "text_color": "#000000"
  },
  {
      "color": "#FF6F00",
      "text_color": "#000000"
  },
  {
      "color": "#E65100",
      "text_color": "#000000"
  },
  {
      "color": "#689F38",
      "text_color": "#000000"
  },
  {
      "color": "#AFB42B",
      "text_color": "#000000"
  },
  {
      "color": "#FBC02D",
      "text_color": "#000000"
  },
  {
      "color": "#FFA000",
      "text_color": "#000000"
  },
  {
      "color": "#F57C00",
      "text_color": "#000000"
  },
  {
      "color": "#8BC34A",
      "text_color": "#000000"
  },
  {
      "color": "#CDDC39",
      "text_color": "#000000"
  },
  {
      "color": "#FFEB3B",
      "text_color": "#000000"
  },
  {
      "color": "#FFC107",
      "text_color": "#000000"
  },
  {
      "color": "#FF9800",
      "text_color": "#000000"
  },
  {
      "color": "#AED581",
      "text_color": "#000000"
  },
  {
      "color": "#DCE775",
      "text_color": "#000000"
  },
  {
      "color": "#FFF176",
      "text_color": "#000000"
  },
  {
      "color": "#FFD54F",
      "text_color": "#000000"
  },
  {
      "color": "#FFB74D",
      "text_color": "#000000"
  },
  {
      "color": "#DCEDC8",
      "text_color": "#000000"
  },
  {
      "color": "#F0F4C3",
      "text_color": "#000000"
  },
  {
      "color": "#FFF9C4",
      "text_color": "#000000"
  },
  {
      "color": "#FFECB3",
      "text_color": "#000000"
  },
  {
      "color": "#FFE0B2",
      "text_color": "#000000"
  },
  {
      "color": "#BF360C",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#3E2723",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#263238",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#000000",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#E64A19",
      "text_color": "#000000"
  },
  {
      "color": "#5D4037",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#455A64",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#525252",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#FF5722",
      "text_color": "#000000"
  },
  {
      "color": "#795548",
      "text_color": "#FFFFFF"
  },
  {
      "color": "#607D8B",
      "text_color": "#000000"
  },
  {
      "color": "#969696",
      "text_color": "#000000"
  },
  {
      "color": "#FF8A65",
      "text_color": "#000000"
  },
  {
      "color": "#A1887F",
      "text_color": "#000000"
  },
  {
      "color": "#90A4AE",
      "text_color": "#000000"
  },
  {
      "color": "#FFCCBC",
      "text_color": "#000000"
  },
  {
      "color": "#D7CCC8",
      "text_color": "#000000"
  },
  {
      "color": "#CFD8DC",
      "text_color": "#000000"
  },
]
export default TaskEditorColorMapping;
